export default __webpack_public_path__ + "static/media/Drowchet_Home.edf27458.png";